import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check\">\n  <path d=\"M14.86 3.6l-.66-.66a.48.48 0 0 0-.67 0l-7.19 7.2-3.87-3.88a.48.48 0 0 0-.67 0l-.66.66a.48.48 0 0 0 0 .66L6 12.46c.17.17.49.17.66 0l8.2-8.2a.48.48 0 0 0 0-.66z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/check.svg
// module id = 430
// module chunks = 0